<script setup>
import ProductCard from '@maison/components/product/ProductCard.vue';
import {
  props as cartContentProps,
  useCartContent,
} from '@phoenix/composables/components/checkout/summary/cartContent';

const props = defineProps({ ...cartContentProps });

const { removeProduct } = useCartContent(props);
</script>

<template>
  <ul class="stack stack--spacing-4 cart-panel__product-cards-list">
    <li v-for="item in cartItems" :key="item.id" data-cy="cart-summary-item">
      <product-card
        v-bind="item"
        :vat-information="item.vatInfo"
        :image="item.imageProductKey"
        should-display-remove-from-cart
        horizontal-only
        :show-tags="false"
        :on-remove="removeProduct"
      >
        <template #price>
          {{ item.price }}
        </template>
      </product-card>
    </li>
  </ul>
</template>
